//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Weld.js";
import "../Weld/Weld.DatumCommonBuilder.js";
import "../Weld/Weld.SelectDatumSurface.js";
import "../no/ScCollector.js";
import "../no/ugmath.js";
import "../no/ScCollector.js";
import "../no/SelectObject.js";
let d=[[[0,"BoundaryCurve",0,"ScCollector",0],[0,"CustomCuboidLength",1,0],[0,"CustomCuboidWidth",1,0],[0,"CustomHollowLength",1,0],[0,"CustomHollowRadius",1,0],[1,"DerivedDatum",0,"Weld.SelectDatumSurface",0],[0,"GridSnapTolerance",1,0],[0,"MirrorPlane",1,"Plane",0],[1,"RestingFace",0,"ScCollector",0],[0,"SnapPointToGrid",1,0],[0,"Type",1,0],[0,"XCoordinate",1,0],[0,"YCoordinate",1,0],[0,"ZCoordinate",1,0]],[[[],"MoveMinimumDistance",{},0,0],[["approximatePoint"],"InitializeAxis",{},1,0],[[],"UpdateAxisData",{},0,0],[[],"UpdateWithReferenceDatum",{},0,0]],[]];
SPLM.Weld.DatumSurfaceBuilder = class extends SPLM.Weld.DatumCommonBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Weld.DatumSurfaceBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Weld.DatumSurfaceBuilder.Types = Object.freeze({
    "Direct" : "Direct", "Mirror" : "Mirror", "Oncurve" : "Oncurve"});

export default SPLM;